// import { makeStyles } from "@material-ui/core/styles";

// const useStyles = makeStyles((theme) => ({
// 	contentContainerGrid: {
// 		width: "100%",
// 		margin: "auto",
// 		marginTop: 86,
// 		[theme.breakpoints.up(theme.breakpoints.values.sm)]: {
// 			minHeight: 'max(calc(100vh - 296px), 700px)',
// 		}
// 	},
// 	welcomeBannerContainer: {
// 		height: 400,
// 		marginBottom: 100,
// 		[theme.breakpoints.down(theme.breakpoints.values.sm)]: {
// 			height: 'auto'
// 		},
// 	},
// 	featuresContainer: {
// 		// marginBottom: 20,
// 		height: '100%',
// 		margin: '0 auto',
// 	}
// }));

// export default useStyles;

import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  contentContainerGrid: {
    width: "100%",
    margin: "0 auto",
    marginTop: 72,
    maxWidth: "87.5rem",
    paddingLeft: 24,
    paddingRight: 24,

    [theme.breakpoints.down("sm")]: {
      marginTop: 20,
      paddingLeft: 16,
      paddingRight: 16,
    },

    [theme.breakpoints.up("lg")]: {
      marginTop: 86,
    },
  },

  welcomeBannerContainer: {
    width: "100%",

    marginBottom: 56,

    [theme.breakpoints.down("sm")]: {
      marginBottom: 36,
    },

    [theme.breakpoints.up("lg")]: {
      marginBottom: 80,
    },
  },

  featuresContainer: {
    width: "100%",
    margin: "0 auto",

    paddingBottom: 24,

    [theme.breakpoints.down("sm")]: {
      paddingBottom: 16,
    },
  },
}));

export default useStyles;
